/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { InputBase, InputBaseProps } from '@mantine/core'
import { IMaskInput, IMaskInputProps } from 'react-imask'

export type PhoneInputProps = InputBaseProps & IMaskInputProps<any>

function PhoneInput (props: PhoneInputProps) {
  const {
    value,
    ...others
  } = props
  return (
    <InputBase
      component={IMaskInput}
      mask="000.00000000"
      placeholder="000.00000000"
      {...others}
      value={typeof value === 'string' ? value : ''}
    />
  )
}

export default PhoneInput
